import { defineMessages } from 'react-intl'

import { AMENITIES } from './constants'

export const amenitiesMessages = defineMessages({
  [AMENITIES.WIFI]: {
    id: 'dictionary.wifi',
    defaultMessage: 'Wifi'
  },
  [AMENITIES.TV]: {
    id: 'dictionary.tv',
    defaultMessage: 'Tv'
  },
  [AMENITIES.ETICKET]: {
    id: 'dictionary.eticket',
    defaultMessage: 'E-ticket'
  },
  [AMENITIES.WC]: {
    id: 'dictionary.wc',
    defaultMessage: 'Wc'
  },
  [AMENITIES.AC]: {
    id: 'dictionary.ac',
    defaultMessage: 'Ac'
  },
  [AMENITIES.CHAIR]: {
    id: 'dictionary.chair',
    defaultMessage: 'Chair'
  },
  [AMENITIES.PLUG]: {
    id: 'dictionary.plug',
    defaultMessage: 'Plug'
  },
  [AMENITIES.LIGHT]: {
    id: 'dictionary.light',
    defaultMessage: 'Light'
  },
  [AMENITIES.EXCURSION_TRIP]: {
    id: 'amenities.excursionTrip',
    defaultMessage: 'Tourism / excursion trip'
  },
  [AMENITIES.LUNCHBOX]: {
    id: 'amenities.lunchbox',
    defaultMessage: 'Lunchbox'
  },
  [AMENITIES.GUIDE]: {
    id: 'amenities.guide',
    defaultMessage: 'Guide / Representative'
  }
})
